import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-tab-support-faq',
  templateUrl: './tab-support-faq.component.html',
  styleUrls: ['./tab-support-faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabSupportFaqComponent implements OnInit {
  panelOpenState = false;
  dataFAQ = [
    {
      question: 'support_questions.question_1.question',
      answer: 'support_questions.question_1.answer',
    },
    {
      question: 'support_questions.question_2.question',
      answer: 'support_questions.question_2.answer',
    },
    {
      question: 'support_questions.question_3.question',
      answer: 'support_questions.question_3.answer',
    },
    {
      question: 'support_questions.question_4.question',
      answer: 'support_questions.question_4.answer',
    },
    {
      question: 'support_questions.question_5.question',
      answer: 'support_questions.question_5.answer',
    },
    {
      question: 'support_questions.question_6.question',
      answer: 'support_questions.question_6.answer',
    },
    {
      question: 'support_questions.question_7.question',
      answer: 'support_questions.question_7.answer',
    },
    {
      question: 'support_questions.question_8.question',
      answer: 'support_questions.question_8.answer',
    },
    {
      question: 'support_questions.question_9.question',
      answer: 'support_questions.question_9.answer',
    },
    {
      question: 'support_questions.question_10.question',
      answer: 'support_questions.question_10.answer',
    },
    {
      question: 'support_questions.question_11.question',
      answer: 'support_questions.question_11.answer',
    },
    {
      question: 'support_questions.question_12.question',
      answer: 'support_questions.question_12.answer',
    },
    {
      question: 'support_questions.question_13.question',
      answer: 'support_questions.question_13.answer',
    },
  ];

  constructor(public readonly baseService: BaseService) {}

  open() {
    this.panelOpenState = true;
  }

  close() {
    this.panelOpenState = false;
  }

  ngOnInit() {}
}
